<template>
  <div class="list-product-variances">
    <b-table
      class="table table-responsive table-bordered mt-5"
      hover
      responsive
      :fields="fields"
      :items="items">
      <template #cell(variancesNameTh)="data">
        <div class="d-flex">
          <div class="d-flex justify-content-center" v-if="data.item.isEdit">
            <input
              class="form-control"
              type="text"
              style="width: 60%"
              v-model="data.item.variancesNameTh" />
          </div>
          <span v-else>{{ data.item.variancesNameTh }}</span>
        </div>
      </template>
      <template #cell(variancesNameEn)="data">
        <div class="d-flex">
          <div class="d-flex justify-content-center" v-if="data.item.isEdit">
            <input
              class="form-control"
              type="text"
              style="width: 60%"
              v-model="data.item.variancesNameEn" />
          </div>
          <span v-else>{{ data.item.variancesNameEn }}</span>
        </div>
      </template>
      <template #cell(quota)="data">
        <div class="d-flex justify-content-center">
          <NumberInput
            v-if="data.item.isEdit"
            v-model.number="data.item.quota"
            min="1"
            :custom-style="{width: '60%'}"/>
          <span v-else>{{ data.item.quota }}</span>
        </div>
      </template>
      <template #cell(action)="data">
        <div v-if="!data.item.isEdit" class="d-flex justify-content-center">
          <button
            class="btn btn-outline-warning"
            style="width: 85px"
            @click="data.item.isEdit = true">
            Edit
          </button>
          <button
            class="btn btn-outline-danger btn-del ml-5"
            @click="deleteItems(data.index)">
            Delete
          </button>
        </div>
        <div v-else class="d-flex justify-content-evenly">
          <button
            class="btn btn-outline-success"
            @click="data.item.isEdit = false">
            Confirm
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import fields from "./fieldsProductVariances.json";
import NumberInput from "components/NumberInput/NumberInput.vue";
export default {
  components: {NumberInput},
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields,
    };
  },
  methods: {
    deleteItems(index) {
      this.$emit("deleteProductVariance", index);
    },
  },
};
</script>
